export const userCreditMessage = ''
export const subscriptionMessage =
  'Provided date range is not valid in your subsciption. Please upgrade your account to view shipments from this date. '
